import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LabelR from '../Simple/LabelR';

class RoundedTitle extends Component {
  state = {
    visible: true,
  };

  handleClick = () => {
    const { onClose, title } = this.props;
    this.setState({ visible: false });
    onClose(title);
  };

  render() {
    const { visible } = this.state;
    const { title, className, style, withClose, required } = this.props;
    return (
      <Fragment>
        {visible && (
          <div id={`${title}__selected`} className={`${className} rounded-title`} style={style}>
            {title} {required && <LabelR />}
            {withClose && (
              <button id={`${title}__close`} type="button" className="close" aria-label="Close" onClick={this.handleClick}>
                <FontAwesomeIcon icon={{ prefix: 'fal', iconName: 'times' }} size="xs" />
              </button>
            )}
          </div>
        )}
      </Fragment>
    );
  }
}

RoundedTitle.defaultProps = {
  className: '',
  style: {},
};

RoundedTitle.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  style: PropTypes.shape({}),
};

export default RoundedTitle;
